export type AssignmentProgressStatus = "not_started" | "in_progress" | "needs_help" | "complete";

export const ASSIGNMENT_PROGRESS_LABELS: Record<AssignmentProgressStatus, string> = {
  not_started: "Not started",
  in_progress: "In progress",
  needs_help: "Needs help",
  complete: "Complete",
};

/** Playful markers, shared across lab, lesson list, and teacher charts. */
export const ASSIGNMENT_PROGRESS_EMOJI: Record<AssignmentProgressStatus, string> = {
  not_started: "🎯",
  in_progress: "🚀",
  needs_help: "🧩",
  complete: "🏆",
};

/** Chart / donut segment colors (match --progress-*-chart in index.css). */
export const PROGRESS_CHART_COLORS = {
  complete: "#22a85a",
  inProgress: "#5b8fd4",
  needsHelp: "#f0a030",
  notStarted: "#8fa88a",
} as const;

export const LAB_PROGRESS_HINTS: Record<AssignmentProgressStatus, string> = {
  not_started: "Open this lesson to begin.",
  in_progress: "You're working on this assignment. Click Check My Work when your code passes all required checks.",
  needs_help:
    "Your last Check My Work didn't pass all required checks. Review the feedback, fix your code, and try again.",
  complete: "You passed all required checks. You can keep experimenting, but you're already credited for this lesson.",
};

/** CSS modifier suffix (e.g. `progress-chip--in_progress`). */
export function progressStatusModifier(status: AssignmentProgressStatus): string {
  return status;
}

export function formatProgressLabel(
  status: AssignmentProgressStatus,
  opts?: { emoji?: boolean }
): string {
  const label = ASSIGNMENT_PROGRESS_LABELS[status];
  if (opts?.emoji === false) return label;
  return `${ASSIGNMENT_PROGRESS_EMOJI[status]} ${label}`;
}
